import './index.css';
import { Link } from 'react-router-dom';
import { useEffect, useState } from 'react';

const Home = () => {
  let homePath = '/login';
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    setIsLoaded(true);
    
    // Create floating particles
    const particlesContainer = document.querySelector('.particles');
    if (particlesContainer) {
      for (let i = 0; i < 25; i++) {
        const particle = document.createElement('div');
        particle.className = 'particle';
        
        // Random properties
        const size = Math.random() * 15 + 5;
        const left = Math.random() * 100;
        const animationDuration = Math.random() * 25 + 15;
        const animationDelay = Math.random() * 10;
        const particleType = Math.random() > 0.7 ? 'circle' : 'square';
        
        particle.style.width = `${size}px`;
        particle.style.height = `${size}px`;
        particle.style.left = `${left}%`;
        particle.style.animationDuration = `${animationDuration}s`;
        particle.style.animationDelay = `${animationDelay}s`;
        particle.style.borderRadius = particleType === 'circle' ? '50%' : '2px';
        particle.style.background = Math.random() > 0.5 
          ? 'rgba(255, 255, 255, 0.4)' 
          : 'rgba(255, 255, 255, 0.2)';
        
        particlesContainer.appendChild(particle);
      }
    }

    // Add mouse move parallax effect
    const handleMouseMove = (e) => {
      const moveX = (e.clientX - window.innerWidth / 2) * 0.01;
      const moveY = (e.clientY - window.innerHeight / 2) * 0.01;
      
      const content = document.querySelector('.content-container');
      if (content) {
        content.style.transform = `translate(${moveX}px, ${moveY}px)`;
      }
    };

    window.addEventListener('mousemove', handleMouseMove);
    
    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
    };
  }, []);

  return (
    <div className={`page ${isLoaded ? 'loaded' : ''}`}>
      <div className="particles"></div>
      <div className="gradient-orbs">
        <div className="orb orb-1"></div>
        <div className="orb orb-2"></div>
        <div className="orb orb-3"></div>
      </div>
      
      <div className="content-container">
        <div className="logo-section">
          <div className="logo-wrapper">
            <img
              src="https://vrplay.in/images/vrplay.png"
              alt="vrplay"
              className="vrplay-img"
            />
            <div className="logo-glow"></div>
          </div>
        </div>
        
        <div className="text-section">
          <h1 className="vrplay-title">
            <span className="title-text">Welcome to VRPLAY</span>
            <div className="title-underline"></div>
          </h1>
          <p className="vrplay-subtitle">
            Where Smart Living Meets Simplicity
          </p>
          <p className="vrplay-description">
            From home automation to security, entertainment to family tracking - everything you need for a connected home. 
            One platform, endless possibilities.
          </p>
        </div>

        <div className="action-section">
        {/*   <div className="launch-badge">
            <span className="pulse-badge">🎉 LAUNCHING TODAY ON PLAY STORE</span>
          </div>

          <div className="offer-card">
            <div className="offer-icon">🎁</div>
            <div className="offer-content">
              <p className="launch-text">
                <span className="highlight-text">FREE Activation</span> for first 200 users!
                <br />
                <span className="offer-terms">Pre-register now*</span>
              </p>
            </div>
          </div>

          <a
              href="https://play.google.com/store/apps/details?id=in.vrplay.tv"
              target="_blank"
              rel="noreferrer"
              className="download-button"
            >
              <span className="download-icon">📥</span>
                Pre-register VRPLAY on the Play Store. Upload your screenshot in the pre-registration form and enjoy FREE activation!
              <span className="button-arrow">→</span>
            </a> */}


          <div className="home-buttons">
            <Link to={homePath} className="home-login-button">
              <span className="button-text">Login to VRPLAY</span>
              <div className="button-glow"></div>
              <div className="button-arrow">→</div>
            </Link>

            {/* <Link to="/pre-register" className="home-register-button">
              <span className="register-badge">🔥</span>
              Pre-Register Now
              <span className="register-badge">🔥</span>
            </Link> */}
          </div>

          {/* <div className="offer-deadline">
            <span className="deadline-text">⏰ Limited Period Offer • Register Before Midnight</span>
          </div> */}

          <div className="feature-pills">
            <span className="pill">Entertainment</span>
            <span className="pill">Smart Home</span>
            <span className="pill">Security</span>
            <span className="pill">Tracking</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;